
export const  LANGUAGES = [ 'de', 'fr', 'en'];

export const  WARNING_THEMES = [ 'success', 'danger', 'warning'];

export const  CATEGORIES = [ 
    {'code':'MUS', 'de':'Musik, Unterhaltung & Show', 'fr':'Musik, Unterhaltung & Show', 'en':'Musik, Unterhaltung & Show'}, 
    {'code':'AUM','de':'Ausstellung & Messen', 'fr':'Ausstellung & Messen', 'en':'Ausstellung & Messen'},
    {'code':'NET','de':'Networking','fr':'Networking', 'en':'Networking'},
    {'code':'KWB','de':'Kurse & Weiterbildung', 'fr':'Kurse & Weiterbildung', 'en':'Kurse & Weiterbildung'}, 
    {'code':'FMK','de':'Familie & Kinder','fr':'Familie & Kinder', 'en':'Familie & Kinder' }, 
    {'code':'SPT','de':'Sport','fr':'Sport', 'en':'Sport'}, 
    {'code':'VER','de':'Vereine', 'fr':'Vereine', 'en':'Vereine'}, 
    {'code':'REI','de':'Reisen', 'fr':'Reisen', 'en':'Reisen'},
    {'code':'ESS','de':'Essen', 'fr':'Essen', 'en':'Essen'},
    {'code':'AND','de':'Andere', 'fr':'Sonstiges', 'en':'Sonstiges'}    
];

export const  PUB_CATEGORIES = [ 
    {'code':'PUB_AUS','de':'Ausgehen', 'fr':'Ausgehen', 'en':'Ausgehen',
      'subs':[
        {'code':'CL','de':'Clubbing', 'fr':'Clubbing', 'en':'Clubbing'},
        {'code':'ST','de':'Spontan-Treff', 'fr':'Spontan-Treff', 'en':'Spontan-Treff'}, 
        {'code':'AUS_DIV','de':'Diverses', 'fr':'Diverses', 'en':'Diverses'}
      ]
    },
    {'code':'PUB_SP','de':'Sport', 'fr':'Sport', 'en':'Sport',
      'subs':[
        {'code':'ST','de':'Schwimmen & Tauchen', 'fr':'Schwimmen & Tauchen', 'en':'Schwimmen & Tauchen'},
        {'code':'KLT','de':'Klettern', 'fr':'Klettern', 'en':'Klettern'}, 
        {'code':'GL','de':'Golf', 'fr':'Golf', 'en':'Golf'},
        {'code':'RS','de':'Rollschuhe / Skateboard', 'fr':'Rollschuhe / Skateboard', 'en':'Rollschuhe / Skateboard'},
        {'code':'FIT','de':'Fitness', 'fr':'Fitness', 'en':'Fitness'},
        {'code':'FAH','de':'Fahrrad', 'fr':'Fahrrad', 'en':'Fahrrad'},
        {'code':'SKS','de':'Ski / Snowbaord', 'fr':'Ski / Snowbaord', 'en':'Ski / Snowbaord'},
        {'code':'TEN','de':'Tennis', 'fr':'Tennis', 'en':'Tennis'},
        {'code':'WAN','de':'Wandern', 'fr':'Wandern', 'en':'Wandern'},
        {'code':'LAU','de':'Laufen', 'fr':'Laufen & Joggen', 'en':'Laufen & Joggen'},
        {'code':'FT','de':'Fussball', 'fr':'Fussball', 'en':'Fussball'},
        {'code':'HOK','de':'Hockey', 'fr':'Hockey', 'en':'Hockey'},
        {'code':'KF','de':'Kampfsport', 'fr':'Kampfsport', 'en':'Kampfsport'},
        {'code':'SP_DIV','de':'Diverses', 'fr':'Diverses', 'en':'Diverses'}
      ]
    }, 
    {'code':'PUB_KL','de':'Kultur','fr':'Kultur', 'en':'Kultur',
    'subs':[
        {'code':'MUA','de':'Museen / Austellungen', 'fr':'Museen / Austellungen', 'en':'Museen / Austellungen'},
        {'code':'THS','de':'Theater & Show', 'fr':'Theater & Show', 'en':'Theater & Show'}, 
        {'code':'FOT','de':'Fotograhie', 'fr':'Fotograhie', 'en':'Fotograhie'},
        {'code':'FLK','de':'Film / Kino', 'fr':'Film / Kino', 'en':'Film / Kino'},
        {'code':'KL_DIV','de':'Diverses', 'fr':'Diverses', 'en':'Diverses'}
      ]
    },
    {'code':'PUB_DIV','de':'Diverses','fr':'Diverses', 'en':'Diverses',
    'subs':[]
    }
];

export const  ACT_CATEGORIES = [ 
    {'code':'ACT_AUS','de':'Ausgehen', 'fr':'Ausgehen', 'en':'Ausgehen',
      'subs':[
        {'code':'CL','de':'Clubbing', 'fr':'Clubbing', 'en':'Clubbing'},
        {'code':'ST','de':'Spontan-Treff', 'fr':'Spontan-Treff', 'en':'Spontan-Treff'}, 
        {'code':'AUS_DIV','de':'Diverses', 'fr':'Diverses', 'en':'Diverses'}
      ]
    },
    {'code':'ACT_SP','de':'Sport', 'fr':'Sport', 'en':'Sport',
      'subs':[
        {'code':'ST','de':'Schwimmen & Tauchen', 'fr':'Schwimmen & Tauchen', 'en':'Schwimmen & Tauchen'},
        {'code':'KL','de':'Klettern', 'fr':'Klettern', 'en':'Klettern'}, 
        {'code':'GL','de':'Golf', 'fr':'Golf', 'en':'Golf'},
        {'code':'RS','de':'Rollschuhe / Skateboard', 'fr':'Rollschuhe / Skateboard', 'en':'Rollschuhe / Skateboard'},
        {'code':'FIT','de':'Fitness', 'fr':'Fitness', 'en':'Fitness'},
        {'code':'FAH','de':'Fahrrad', 'fr':'Fahrrad', 'en':'Fahrrad'},
        {'code':'SKS','de':'Ski / Snowbaord', 'fr':'Ski / Snowbaord', 'en':'Ski / Snowbaord'},
        {'code':'TEN','de':'Tennis', 'fr':'Tennis', 'en':'Tennis'},
        {'code':'WAN','de':'Wandern', 'fr':'Wandern', 'en':'Wandern'},
        {'code':'LAU','de':'Laufen', 'fr':'Laufen & Joggen', 'en':'Laufen & Joggen'},
        {'code':'FT','de':'Fussball', 'fr':'Fussball', 'en':'Fussball'},
        {'code':'HOK','de':'Hockey', 'fr':'Hockey', 'en':'Hockey'},
        {'code':'KF','de':'Kampfsport', 'fr':'Kampfsport', 'en':'Kampfsport'},
        {'code':'SP_DIV','de':'Diverses', 'fr':'Diverses', 'en':'Diverses'}
      ]
    }, 
    {'code':'ACT_KL','de':'Kultur','fr':'Kultur', 'en':'Kultur',
    'subs':[
        {'code':'MUA','de':'Museen / Austellungen', 'fr':'Museen / Austellungen', 'en':'Museen / Austellungen'},
        {'code':'THS','de':'Theater & Show', 'fr':'Theater & Show', 'en':'Theater & Show'}, 
        {'code':'FOT','de':'Fotograhie', 'fr':'Fotograhie', 'en':'Fotograhie'},
        {'code':'FLK','de':'Film / Kino', 'fr':'Film / Kino', 'en':'Film / Kino'},
        {'code':'KL_DIV','de':'Diverses', 'fr':'Diverses', 'en':'Diverses'}
      ]
    }, 
   
    {'code':'ACT_TIE','de':'Tiere', 'fr':'Tiere', 'en':'Tiere',
    'subs':[
        {'code':'BHF','de':'Bauernhofe', 'fr':'Bauernhofe', 'en':'Bauernhofe'},
        {'code':'GG','de':'Gasse gehen', 'fr':'Gasse gehen', 'en':'Gasse gehen'}, 
        {'code':'VER','de':'Vermisst', 'fr':'Vermisst', 'en':'Vermisst'},
        {'code':'TIE_DIV','de':'Diverses', 'fr':'Diverses', 'en':'Diverses'}
      ]
    },
    {'code':'DIV','de':'Diverses', 'fr':'Diverses', 'en':'Diverses'}
];



export const BOOKING_STATUS = ['REQUEST', 'IN_PROGRESS', 'RESERVED', 'CANCELD', 'REJECTED'];

export const USER_TYPES = ['REGISTERED','ACTIVE', 'INVITED','BLOCKED', 'INACTIVE', 'LOCKED'];

export const USER_ROLES = [ 'ADMIN', 'MANAGER', 'PARTNER', 'COOPERATOR', 'EVENT_CREATOR', 'INVITED', 'USER'];


export const BOOKING_TYPES = [
    {"label":"bookingIntern", "value":"INTERN"}, 
    {"label":"bookingExtern", "value":"EXTERN"}, 
    {"label":"bookingNone", "value":"NONE"}];


    export const EVENT_STATISTICS = [
      {"label":"Erstellte Erreignisse (1 Tag)", "value":"E01"}, 
      {"label":"Erstellte Anlässe (1 Tag)", "value":"P70_ID"}, 
      {"label":"Musik, Unterhaltung & Show (1 Tag)", "value":"P70_EVENT_KATEGORY_MUS"}
    
      //P70_EVENT_KATEGORY_AUM Musik, Unterhaltung & Show (1 Tag)
      //P70_EVENT_KATEGORY_NET 
    
    ];
  


export const CITIES = [
    {"en":"Zurich", "de":"Zürich", "fr":"Zurich", "zipcode":"8000"},
    {"en":"Geneva", "de":"Genf", "fr":"Genève", "zipcode":"1200"},
    {"en":"Basel", "de":"Basel", "fr":"Bâle", "zipcode":"4000"},
    {"en":"Lausanne", "de":"Lausanne", "fr":"Lausanne", "zipcode":"1000"},
    {"en":"Bern", "de":"Bern", "fr":"Berne", "zipcode":"3000"},
    {"en":"Winterthur", "de":"Winterthur", "fr":"Winterthour", "zipcode":"8400"},
    {"en":"Lucerne", "de":"Luzern", "fr":"Lucerne", "zipcode":"6000"},
    {"en":"St. Gallen", "de":"St. Gallen", "fr":"Saint-Gall", "zipcode":"9000"},
    {"en":"Lugano", "de":"Lugano", "fr":"Lugano", "zipcode":"9000"},
    {"en":"Biel", "de":"Biel", "fr":"Bienne" , "zipcode":"2500"},
    {"en":"Thun", "de":"Thun", "fr":"Thoune", "zipcode":"3600"},
    {"en":"Bellinzona", "de":"Bellinzona", "fr":"Bellinzone", "zipcode":"6500"},
    {"en":"Köniz", "de":"Köniz", "fr":"Köniz", "zipcode":"3098"},
    {"en":"Fribourg", "de":"Freiburg", "fr":"Fribourg", "zipcode":"1700"},
    {"en":"La Chaux-de-Fonds", "de":"Neuchâtel", "fr":"La Chaux-de-Fonds", "zipcode":"2300"},
    {"en":"Shaffhouse", "de":"Schaffhausen", "fr":"Schaffhouse", "zipcode":"8200"},
    {"en":"Chur", "de":"Chur", "fr":"Coire", "zipcode":"7000"},
    {"en":"Vernier", "de":"Vernier", "fr":"Vernier", "zipcode":"1214"},
    {"en":"Uster", "de":"Uster", "fr":"Uster", "zipcode":"8610"},
    {"en":"Sion", "de":"Sitten", "fr":"Sion", "zipcode":"1950"}
]; 